import React, { useState } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProductGrid } from './components/ProductGrid';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { BoxBuilder } from './components/BoxBuilder';
import { SocialProofToast } from './components/SocialProofToast';
import { Cookie } from './types';
export function App() {
  const [boxItems, setBoxItems] = useState<Cookie[]>([]);
  const handleAdd = (cookie: Cookie) => {
    setBoxItems([...boxItems, cookie]);
  };
  const handleRemove = (cookieId: string) => {
    const index = boxItems.findIndex(item => item.id === cookieId);
    if (index !== -1) {
      const newItems = [...boxItems];
      newItems.splice(index, 1);
      setBoxItems(newItems);
    }
  };
  return <div className="min-h-screen bg-brand-pink font-sans text-brand-purple selection:bg-brand-purple selection:text-white pb-52 sm:pb-32" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <Header data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProductGrid boxItems={boxItems} onAdd={handleAdd} onRemove={handleRemove} data-id="element-5" />
        <FAQ data-id="element-6" />
      </main>

      <Footer data-id="element-7" />

      <BoxBuilder boxItems={boxItems} data-id="element-8" />
      <SocialProofToast data-id="element-9" />
    </div>;
}